import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'pcg-alert-modal',
    templateUrl: './alert-modal.component.html',
    styleUrls: ['./alert-modal.component.scss']
})

export class AlertModalComponent {
    @Input() message: string = 'Are you sure?';
    @Input() confirmCallback?: () => void; 

    @Output() confirm = new EventEmitter<void>(); 
    @Output() close = new EventEmitter<void>();  
    
    @ViewChild('confirmButton') confirmButton!: ElementRef<HTMLButtonElement>;

    // Confirm action handler
    onConfirm(): void {
        if (this.confirmCallback) { this.confirmCallback(); }
        this.confirm.emit();
    }

    onClose(): void { this.close.emit(); }

    ngAfterViewInit(): void {
        this.confirmButton.nativeElement.focus();
    }
}